import type { FC, PropsWithChildren } from 'react';

import { useMobileNavigationStore } from '@dcentralexpedientedigital/fe-shared/stores/mobile-navigation-store';
import { useConfig } from '@dcentralexpedientedigital/fe-ui/hooks/use-config';
import { useMediaQuery } from '@dcentralexpedientedigital/fe-ui/hooks/use-media-query';
import { useScrollDirection } from '@dcentralexpedientedigital/fe-ui/hooks/use-scroll-direction';
import { makeClassesByStyles } from '@dcentralexpedientedigital/fe-ui/utils/classes';

export interface ITopNavProps {
    className?: string;
    withActionButtons?: boolean;
}
const cx = makeClassesByStyles();

export const TopNav: FC<PropsWithChildren<ITopNavProps>> = ({ className, children }) => {
    const scrollDirection = useScrollDirection();
    const isLg = useMediaQuery('lg');
    const {
        topMenuConfig: { hideNavBehaviourMobile },
    } = useConfig();
    const [isMobileNavOpen] = useMobileNavigationStore((state) => [state.isMobileNavigationOpen]);

    return (
        <div
            id="top-nav"
            className={cx(className, 'bg-top-nav-bg w-full sticky top-0 z-20', {
                'transition-transform duration-[400ms] ease-in-out transform':
                    hideNavBehaviourMobile,
                'py-2': !!isLg || (!isLg && !isMobileNavOpen),
                '-translate-y-full': hideNavBehaviourMobile && !isLg && scrollDirection === 'down',
                'translate-y-0': hideNavBehaviourMobile && !isLg && scrollDirection === 'up',
            })}
        >
            {children}
        </div>
    );
};
